import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class OrderHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient, private accountService: AccountService) {}

    getOrdersByDate(date: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/order/getOrdersByDate`, {
            params: { date: date, branchId: this.accountService.currentUser.branchId },
        });
    }

    getOrderbyId(orderMasterId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/order/getOrderbyId`, { params: { orderMasterId: orderMasterId } });
    }

    getOrderDetailsbyId(orderMasterId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/order/getOrderDetailsbyId`, { params: { orderMasterId: orderMasterId } });
    }

    acceptOrderById(orderMasterId: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/order/acceptOrderById`, {}, { params: { orderMasterId: orderMasterId } });
    }

    inDeliveryOrderById(orderMasterId: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/order/inDeliveryOrderById`, {}, { params: { orderMasterId: orderMasterId } });
    }

    deliveredOrderById(orderMasterId: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/order/deliveredOrderById`, {}, { params: { orderMasterId: orderMasterId } });
    }

    cancelOrderById(orderMasterId: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/order/cancelOrderById`, {}, { params: { orderMasterId: orderMasterId } });
    }
}
